import styled from 'styled-components';
import { BasicSectionContainer } from '../../../style';

export const AccountContentContainer = styled(BasicSectionContainer)`
  min-height: 50vh;
  padding-top: 5%;
  display: flex;
  justify-content: center;
`;